<template lang="pug">
  th.column-sortable(
      :class='sortOrderClass',
      :title="data.tooltip",
      @click.stop.prevent='$emit("toggleOrder", data.id)'
    )
    span(v-html="data.label")
</template>

<script>
const ASC = 'ASC'
const DESC = 'DESC'
import Tooltip from 'tether-tooltip'

export default {
  name: 'table-header-cell',
  props: [ 'data' ],
  data () {
    return { tooltip: null }
  },
  computed: {
    sortOrderClass () {
      if (this.data.order === ASC) {
        return 'sort-order-asc'
      }
      if (this.data.order === DESC) {
        return 'sort-order-desc'
      }
      return 'sort-order-none'
    }
  },
  methods: {
  },
  mounted () {
    this.tooltip = new Tooltip({
      target: this.$el,
      content: this.data.tooltip
    })
  }
}
</script>

<style src="tether-tooltip/dist/css/tooltip-theme-arrows.css"></style>

<style lang="stylus" scoped>
th {
  cursor: pointer
  &:after {
    content: ''
    border-color: transparent
    border-style: solid
    border-width: 5px
    display: inline-block
    font-size: 0
    line-height: 0
    height: 0
    width: 0
    vertical-align: 3px
    margin: 0 0 0 10px
    opacity: .6
  }

  &.sort-order-desc {
    &:hover:after {
      border-top-color: #000
      opacity: 1
    }
    &:after {
      border-top-color: #333
      border-bottom-width: 0
    }
  }

  &.sort-order-asc {
    &:hover:after {
      border-bottom-color: #000
      opacity: 1
    }
    &:after {
      border-bottom-color: #333
      border-top-width: 0
    }
  }
}
</style>



// WEBPACK FOOTER //
// table-header-cell.vue?502e6a02